import { VmwareSVG } from '@sbercloud/uikit-product-icons';
import { PLATFORM } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var VM_WARE_PLATFORM = {
  id: PLATFORM.VmWare,
  icon: /*#__PURE__*/_jsx(VmwareSVG, {}),
  label: 'Облако VMware',
  description: 'Облачная инфраструктура на базе технологий VMware',
  access: 'legal',
  dataTestId: 'calculator-catalog-platform-enterprise'
};